import { Pressable, View } from 'react-native';
import { Text } from '@/components/ui/text';
import { useTranslation } from 'react-i18next';
import { Gender } from '~/graphql/generated/graphql';

const GENDER_ORDER: Gender[] = [
  Gender.Male,
  Gender.Female,
  Gender.Other,
  Gender.PreferNotToSay,
];

export interface GenderSelectorProps {
  selected: Gender | null | undefined;
  onSelect: (gender: Gender) => void;
}

export const GenderSelector = ({ selected, onSelect }: GenderSelectorProps) => {
  const { t } = useTranslation('user');

  return (
    <View className="flex flex-row gap-2">
      {GENDER_ORDER.map((gender) => {
        const isActive = selected === gender;
        return (
          <Pressable
            key={gender}
            onPress={() => onSelect(gender)}
            className={`flex-1 items-center justify-center rounded-lg py-2.5 px-4 ${
              isActive ? 'bg-accent' : 'bg-surface-elevated'
            }`}
          >
            <Text
              className={`text-[13px] font-medium ${
                isActive ? 'text-text-primary' : 'text-text-secondary'
              }`}
            >
              {t(`settings.gender.${gender}`)}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};
